export default "__VITE_ASSET__D5S1avNZ__";